import { Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout, AuthLayout } from '@/core/layouts';
import { PrivateRoute } from './PrivateRoute';
import {
  LazyLoginForm,
  LazyRegisterForm,
  LazyEmailVerification,
  LazyForgotPassword,
  LazyResetPassword,
  LazyDashboard,
  LazyInitialDashboard,
  LazyAlerts,

  // Repository routes
  LazyApps,
  LazyFirmware,
  LazyKeyManagement,
  LazyTaskAutomation,

  // Management routes
  LazyDevices,
  DeviceDashboard,
  LazyDeviceGroups,
  LazyTemplates,
  LazySchedules,

  // System routes
  LazyGeneral,
  LazyClients,
  LazyProjects,
  LazyLocation,
  LazyUsers,
  LazyRolesProfiles,

  // Integrations
  LazyIntegrations,
  LazyReports,
  LazyLogs,
  LazyAddDevice,

  LazyProfiles,
  // Footer page link 
  LazyPrivacyPolicy,
  LazyTermsofService,
  LazyContactUs,
  // LazyAakashTracker,
  ProjectDashboard,
  
} from './lazyRoutes';

export const AppRoutes = () => (
  <Routes>
    {/* Auth Routes */}
    <Route element={<AuthLayout />}>
      <Route path="/login" element={<LazyLoginForm />} />
      <Route path="/register" element={<LazyRegisterForm />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/verify-email/:uidb64/:token" element={<LazyEmailVerification />} />
      <Route path="/forgot-password" element={<LazyForgotPassword />} />
      <Route path="/reset-password/:uidb64/:token" element={<LazyResetPassword />} />
    </Route>

    {/* Protected Routes */}
    <Route element={<MainLayout />}>
      <Route path="/logs" element={<PrivateRoute><LazyLogs /></PrivateRoute>} />
      <Route path="/reports" element={<PrivateRoute><LazyReports /></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><LazyProfiles /></PrivateRoute>} />
      {/* Main Menu Items */}
      <Route path="/dashboard" element={<PrivateRoute><LazyDashboard /></PrivateRoute>} />
      <Route path="/alerts" element={<PrivateRoute><LazyAlerts /></PrivateRoute>} />

      {/* Repository Routes */}
      <Route path="/repository/apps" element={<PrivateRoute><LazyApps /></PrivateRoute>} />
      <Route path="/repository/firmware" element={<PrivateRoute><LazyFirmware /></PrivateRoute>} />
      <Route path="/repository/key-management" element={<PrivateRoute><LazyKeyManagement /></PrivateRoute>} />
      <Route path="/repository/task-automation" element={<PrivateRoute><LazyTaskAutomation /></PrivateRoute>} />

      {/* Management Routes */}
      <Route path="/management/devices" element={<PrivateRoute><LazyDevices /></PrivateRoute>} />
      <Route path="/management/devices/add" element={<PrivateRoute><LazyAddDevice /></PrivateRoute>} />
      <Route path="/management/device-groups" element={<PrivateRoute><LazyDeviceGroups /></PrivateRoute>} />
      <Route path="/management/templates" element={<PrivateRoute><LazyTemplates /></PrivateRoute>} />
      <Route path="/management/schedules" element={<PrivateRoute><LazySchedules /></PrivateRoute>} />

      {/* System Routes */}
      <Route path="/system/general" element={<PrivateRoute><LazyGeneral /></PrivateRoute>} />
      <Route path="/system/clients" element={<PrivateRoute><LazyClients /></PrivateRoute>} />
      <Route path="/system/projects" element={<PrivateRoute><LazyProjects /></PrivateRoute>} />
      <Route path="/system/location" element={<PrivateRoute><LazyLocation /></PrivateRoute>} />
      <Route path="/system/users" element={<PrivateRoute><LazyUsers /></PrivateRoute>} />
      <Route path="/system/roles-profiles" element={<PrivateRoute><LazyRolesProfiles /></PrivateRoute>} />

      {/* Other Routes */}
      <Route path="/integrations" element={<PrivateRoute><LazyIntegrations /></PrivateRoute>} />

      {/* Device Detail Routes */}
      <Route path="/management/devices/:device/:tab" element={<PrivateRoute><DeviceDashboard /></PrivateRoute>} />
      <Route path="/management/devices/:device" element={<PrivateRoute><DeviceDashboard /></PrivateRoute>} />

      <Route path="/get-started" element={<PrivateRoute><LazyInitialDashboard /></PrivateRoute>} />
      <Route path="/privacy-policy" element={<PrivateRoute><LazyPrivacyPolicy /></PrivateRoute>} />
      <Route path="/terms-of-service" element={<PrivateRoute><LazyTermsofService /></PrivateRoute>} />
      <Route path="/contact-us" element={<PrivateRoute><LazyContactUs /></PrivateRoute>} />

      {/* aakash tracker */}
      {/* <Route path="/tracker" element={<PrivateRoute><LazyAakashTracker /></PrivateRoute>} /> */}

      {/* {PROJECTDASHBOARD} */}
      <Route path="/system/project/:project" element={<PrivateRoute><ProjectDashboard /></PrivateRoute>} />
    </Route>

    {/* Catch all route - redirect to login */}
    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);